"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const predicates_1 = require("../predicates");
exports.below = (ceiling) => (value) => predicates_1.isNumber(value) && value < ceiling;
//# sourceMappingURL=below.js.map